import { Icon } from '@chakra-ui/react';
import { MdDashboard, MdLock, MdPerson, MdShowChart, MdTrendingUp } from 'react-icons/md';

// Admin Imports
import LiveSimulator from 'views/admin/simulator';
import ForecastAdmin from 'views/admin/forecast';
import UserManager from 'views/admin/users';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import ResetPassword from 'views/auth/forgotPassword';
import Dashboards from 'views/admin/dashboardElements';

const routes = [
	{
		name: 'Tableros',
		layout: '/dashboards',
		path: '/elements',
		moduleName: 'Dashboards',
		icon: <Icon as={MdDashboard} width='20px' height='20px' color='inherit' />,
		component: Dashboards
	},
	{
		name: 'Simulador',
		layout: '/coverage',
		path: '/simulator',
		moduleName: 'Coverage simulator',
		icon: <Icon as={MdShowChart} width='20px' height='20px' color='inherit' />,
		component: LiveSimulator
	},
	{
		name: 'Forecast',
		layout: '/coverage',
		path: '/forecast',
		moduleName: 'Coverage simulator',
		icon: <Icon as={MdTrendingUp} width='20px' height='20px' color='inherit' />,
		component: ForecastAdmin
	},
	{
		name: 'Usuarios y Grupos',
		layout: '/users',
		path: '/manage',
		moduleName: 'Custom auth',
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: UserManager
	},
	{
		name: 'Login',
		layout: '/auth',
		path: '/sign-in',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: SignInCentered
	},
	{
		name: 'Resetear Clave',
		layout: '/auth',
		path: '/forgot-password',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: ResetPassword
	}
];

export default routes;
